import { Navigate } from 'react-router-dom';

/**
 * ルートにアクセスしたときのリダイレクト用のコンポーネント
 * TODO:中身はサンプルのため仕様が確定したのちに置き換える
 */
export function Redirect() {
  return <Navigate to="/edit" replace />;
}
